export default __webpack_public_path__ + "static/media/empty-01.0c647b0a.svg";